import { HotelServiceEnum, HotelTypeEnum } from '@appTypes/api.types';
import { IValueLabel } from '@appTypes/common.types';
import { environment } from '@env/environment';

export const STATIC_OPTONS_HOTEL_SERVICES: IValueLabel<HotelServiceEnum>[] = [
  { label: 'Alcohol', icon: 'alcohol', value: HotelServiceEnum.HasAlcohol },
  { label: 'Internet', icon: 'wifi', value: HotelServiceEnum.HasFreeWifi },
  { label: 'Metro', icon: 'metro', value: HotelServiceEnum.HasMetro },
  { label: 'Pool', icon: 'pool', value: HotelServiceEnum.HasPool },
  { label: 'Mall', icon: 'mall', value: HotelServiceEnum.HasMall }
];
export const STATIC_OPTONS_HOTEL_TYPES: IValueLabel<HotelTypeEnum>[] = [
  { label: 'City Hotel', value: HotelTypeEnum.CityHotel },
  { label: 'Beach Hotel', value: HotelTypeEnum.BeachHotel },
  { label: 'Second Line', value: HotelTypeEnum.SecondLineBeach }
];
export const STATIC_OPTIONS_HOTEL_CLASSES_STARS: IValueLabel<string>[] = [
  { value: '1', label: '{value} Star' },
  { value: '2', label: '{value} Stars' },
  { value: '3', label: '{value} Stars' },
  { value: '4', label: '{value} Stars' },
  { value: '5', label: '{value} Stars' },
  { value: '6', label: 'Apartment' }
];
export const STATIC_OPTIONS_HOTEL_MEAL_PLANS: IValueLabel[] = [
  { label: 'Room only', value: 'RO' },
  { label: 'Bed & Breakfast', value: 'BB' },
  { label: 'Half Board', value: 'HB' },
  { label: 'Full Board', value: 'FB' },
  { label: 'Half Board Transfer', value: 'HBT' },
  { label: 'Full Board Transfer', value: 'FBT' },
  { label: 'All Inclusive', value: 'AL' }
];
export const PAGINATION_LEVELS: IValueLabel[] = [
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: -1, label: 'All' }
];

/** The child ages the search forms offer: 1..environment.childMaxAge (17, online-api#67 - an 18 was refused by the price rules). */
export const CHILDRAN_AGES: IValueLabel[] = Array.from(Array(environment.childMaxAge).keys()).map((i) => ({
  value: i + 1,
  label: `${i + 1}`
}));
